// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".marketing-hint[data-v-3e20fa56]{align-items:center;color:#fff;display:inline-flex;font-weight:700;padding:0 15px 0 10px;white-space:normal}.marketing-hint .icon-svg[data-v-3e20fa56],.marketing-hint__icon[data-v-3e20fa56]{margin-right:5px}.marketing-hint__icon[data-v-3e20fa56]{filter:invert(1);height:1em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
